import { Suspense, lazy, type ComponentType, type ReactElement } from 'react';
import { FullscreenLoader } from '@/shared/ui';

/**
 * Code-split a route page exported by name and render it inside Suspense.
 * Route pages take no props (params come from the router), so this stays
 * deliberately prop-less.
 *
 * Route-level splitting keeps the staff-only surfaces (editor, admin) out of the
 * bundle public readers download — they were ~half of a single 846 kB chunk.
 */
export function lazyPage(
  load: () => Promise<Record<string, ComponentType>>,
  exportName: string,
): () => ReactElement {
  const Component = lazy(async () => {
    const module = await load();
    const resolved = module[exportName];
    if (!resolved) throw new Error(`Module has no export named "${exportName}"`);
    return { default: resolved };
  });

  return function LazyPage() {
    return (
      <Suspense fallback={<FullscreenLoader />}>
        <Component />
      </Suspense>
    );
  };
}
